<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <input id="fileInput" type="file" style="display:none" v-on:change="chooseFile()" accept="application/json"/>
            <ProvideCredo v-model="passwordModal" ref="credoDialog"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlECMRepoImport}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class=" OTSecondary" @click.native="open" id="OTECMChooseFile" :title="ecmResourceStrings.tipECMChooseFile" >{{ecmResourceStrings.lblChooseFile}}</otif-button>
                <otif-button class=" OTPrimary" @click.native="save" id="OTSaveSetting" :title="ecmResourceStrings.tipECMSaveConfig" :disabled="filetext === ''" >{{ecmResourceStrings.lblSave}}</otif-button>
            </b-col>
        </b-row>
        <otif-textInput
            v-bind:label="ecmResourceStrings.lblFileName"
            v-bind:readonly=true
            :disabled=true
            :description="ecmResourceStrings.txtECMChooseFile"
            v-model="form.filename"/>
        <b-row>
            <b-col>
                <p>
                    {{ecmResourceStrings.txtFileContent}}
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <span v-html="HTMLcontent" id="textarea" class="htmltextarea"></span>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import ProvideCredo from '../../modals/ECMCrawlerPassword.vue';
import { showMessage} from '../../../utils/commonECM.js';

export default {
    components: {
         ECMErrorDialog,
         ProvideCredo,
     },

    data() {
        return {
            passwordModal: false,
            HTMLcontent: null,
            messageDlg:false,
            loaded: false,
            filetext:'',
            ecmResourceStrings: require('../../../utils/resourceECM.js'),
            form:{
                filename:'',
            },
        }
    },

    watch: {
        passwordModal(newVal) {
            if (newVal === true) {
            }
        }
    },

    methods: {

        saveConfirmed(password)
        {
            this.passwordModal = false;
            var jsonObject = undefined;
            try
            {
                jsonObject = JSON.parse(this.filetext);
                if(jsonObject)
                {
                    //replace password in text
                    jsonObject.password = password;
                    const connString = JSON.stringify(jsonObject); 
                    this.$snotify.async(this.ecmResourceStrings.txtStartSaving, {timeout: 0});
                    axios.put('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/ECM', connString, 
                        {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                    .then((res) => {
                        this.$snotify.clear();
                        this.$snotify.success(this.ecmResourceStrings.txtECMConfigSaved);
                        this.$router.push('/settings/ecmrepository');
                    })
                    .catch((err) => {
                        const error = err.toString();
                        this.$snotify.clear();
                        this.$snotify.error(error);
                    });
                }
            }
            catch(e)
            {
                const error = e.toString();
                this.$snotify.clear();
                this.$snotify.error(error);
            }
        },

        save()
        {
            var jsonObject = undefined;
            try
            {
                jsonObject = JSON.parse(this.filetext);
                if(jsonObject)
                {
                    const connString = JSON.stringify(jsonObject); 
                    this.$snotify.async(this.ecmResourceStrings.txtStartSaving, {timeout: 0});
                    axios.put('/mtm-gateway-api/v1/services/ecm/CrawlerRepositories/ECM', connString, 
                        {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                    .then((res) => {
                        this.$snotify.clear();
                        this.$snotify.success(this.ecmResourceStrings.txtECMConfigSaved);
                        this.$router.push('/settings/ecmrepository');
                    })
                    .catch((err) => {
                        const error = err.toString();
                        this.$snotify.clear();
                        this.$snotify.error(error);
                    });
                }
            }
            catch(e)
            {
                const error = e.toString();
                this.$snotify.clear();
                this.$snotify.error(error);
            }
        },

        open(){
            const event = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
            });
            const element = document.getElementById('fileInput');
            if(element)
            {
                element.dispatchEvent(event);
            }
        },

        chooseFile()
        {
            var that = this;
            const element = document.getElementById('fileInput');
            if(element)
            {
                if(element.files.length == 0)
                {
                    //cancel was pressed, nothing changed
                }
                for (let file of element.files) {
                    that.filetext='';
                    that.form.filename =element.files[0].name;
                    that.readFile(element.files[0]);
                }
            }
        },

        readFile(filex) {
            var that = this;
            const start = 0;
            const stop = filex.size - 1;
            var reader = new FileReader();
            reader.onloadend = function(evt)
            {
                if (evt.target.readyState == FileReader.DONE)// DONE == 2
                {
                    that.filetext =  evt.target.result;
                    that.getText('json');
                }
            };
            const blob = filex.slice(start, stop + 1);
            reader.readAsText(blob, 'UTF-8');   // reader.readAsBinaryString(blob);
        },

        getText(type)
        {
            var that = this;
             if(that.filetext)
            {
                var jsonObject = undefined;
                try
                {
                    jsonObject = JSON.parse(that.filetext);
                    if(jsonObject)
                    {
                        that.getHTMLTextFromJson(jsonObject);
                    }
                }
                catch(e)
                {
                    const divHTML = 'No preview available';
                    const element = document.getElementById('textarea');
                    if(element)
                    {
                        element.innerHTML = divHTML;
                    }
                    this.filetext = '';
                    showMessage(this, 'error', this.ecmResourceStrings.txtError,this.ecmResourceStrings.txtECMReadFileError, true, e.toString());
                }
            }
        },

        getHTMLTextFromJson:function(jsonObject)
        {
            if(jsonObject)
            {
                const testConnectivity = jsonObject.connectivity;
                const oticUser = jsonObject.oticUser;
                const driver = jsonObject.driver;
                if(testConnectivity && driver && oticUser == undefined)
                {
                    const firstspace = '        ';
                    const distance = '  ';
                    var divHTML = "<div id='response-body-highlight' class='tab-pane' >";
                    divHTML += "<pre style='margin-left:0px; padding: 5px 0; line-height: 1.6em;' >";
                    divHTML += "<code>{" ;

                    divHTML += "&#13;&#10;" + firstspace;
                    divHTML +=  "<span class='ajn'>&#34;connectivity&#34;</span>";
                    divHTML += "<span class='pun'>" + distance + ":" + distance +"</span>";
                    divHTML +=  "<span class='value'><span class='jtv'>" + jsonObject.connectivity + "</span></span>,";

                    divHTML += "&#13;&#10;" + firstspace;
                    divHTML +=  "<span class='ajn'>&#34;driver&#34;</span>";
                    divHTML += "<span class='pun'>" + distance + ":" + distance +"</span>";
                    divHTML +=  "<span class='jtv'>&#34;" + jsonObject.driver + "&#34;</span>,";

                    divHTML += "&#13;&#10;" + firstspace;
                    divHTML +=  "<span class='ajn'>&#34;url&#34;</span>";
                    divHTML += "<span class='pun'>" + distance + ":" + distance +"</span>";
                    divHTML +=  "<span class='value'><span class='jtv'>&#34;" + jsonObject.url + "&#34;</span></span>,";

                    divHTML += "&#13;&#10;" + firstspace;
                    divHTML +=  "<span class='ajn'>&#34;user&#34;</span>";
                    divHTML += "<span class='pun'>" + distance + ":" + distance +"</span>";
                    divHTML +=  "<span class='value'><span class='jtv'>&#34;" + jsonObject.user + "&#34;</span></span>,";

                    divHTML += "&#13;&#10;" + firstspace;
                    divHTML +=  "<span class='ajn'>&#34;password&#34;</span>";
                    divHTML += "<span class='pun'>" + distance + ":" + distance +"</span>";
                    divHTML +=  "<span class='value'><span class='jtv'>&#34;" + "*****" + "&#34;</span></span>,";

                    divHTML += "&#13;&#10;}";
                    //end
                    divHTML += "</code>"
                    divHTML += "</pre>";
                    divHTML += "</div>";

                    const element = document.getElementById('textarea');
                    if(element)
                    {
                        element.innerHTML = divHTML;
                    }
                }
                else
                {
                    const divHTML = 'No preview available';
                    const element = document.getElementById('textarea');
                    if(element)
                    {
                        element.innerHTML = divHTML;
                    }
                    this.filetext = '';
                    showMessage(this, 'error', this.ecmResourceStrings.txtError,'', true, this.ecmResourceStrings.txtECMReadFileInfo);
                }
            }
        },
    },

    mounted() {
         var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repo-settings',
            meta: { label: 'Crawling Service' }
        },{
            name: 'ecm-repo-import',
            meta: { label: 'Import ECM Repository Configuration' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
        this.$refs.credoDialog.dlgtitle = 'Save ECM Crawler repository configuration';
    },

    created() {
        var that = this;
        that.loaded = true;
    },

}
</script>